export default {
  SET_ORDER_LIST: 'SET_ORDER_LIST',
  SET_ORDERLIST_PARAMS: 'SET_ORDERLIST_PARAMS',
  SET_SINGLE_ORDER_PARAMS: 'SET_SINGLE_ORDER_PARAMS',
  SET_HIDING_ORDER_MODULES: 'SET_HIDING_ORDER_MODULES',
};
